import productApi from '@/service/modules/productApi'
import { useEffect, useState } from 'react'
import styles from '@/styles/productDetail/productDetail.module.scss'
import { Image, message, Tabs, Modal, Button } from 'antd';
import { debounce, offSet } from '@/utils/utils';
import FineMore from './FineMore';
import PinItSvg from '@/svgs/Pin_it.svg'
export default function ProductDetail(props: any) {

  const [isBetween, setIsBetween] = useState(false);
  // 默认有review模块
  const [items, setItems] = useState([{
    key: 'product-reviews',
    label: 'Reviews'
  }])
  useEffect(() => {
    function handleScroll() {
      const element1 = document.getElementById('product-information');
      const element2 = document.getElementById('paymentNotice');
      const newArrivals = document.getElementById('goods-detail-tabs');
      const scrollPosition = window.scrollY;

      // 监听是否在两个元素之间、要做吸顶处理
      if (element1 && element2) {
        const rect1 = element1.getBoundingClientRect();
        const rect2 = element2.getBoundingClientRect();
        const newArrivalsRect = newArrivals ? newArrivals.getBoundingClientRect() : { height: 0 }
        if (scrollPosition > (rect1.top) + scrollPosition && scrollPosition < (rect2.top - newArrivalsRect.height - 25) + scrollPosition) {
          setIsBetween(true);
        } else {
          setIsBetween(false);
        }
      } else {
        setIsBetween(false);
      }

      // 监听滚动到哪个模块了
      items.forEach((item: any) => {
        calculateFunction(document.getElementById(item.key), item.key)
      })
    }

    // const debouncedScroll = debounce(handleScroll, 50)
    const debouncedScroll = handleScroll
    window.addEventListener('scroll', debouncedScroll);
    handleScroll(); // Initial check

    return () => {
      window.removeEventListener('scroll', debouncedScroll);
    };
  }, [items]);

  // 监测宽度变化,动态跳转ipad设配
  useEffect(() => {
    function handleResize() {
      const width = document.getElementById("goods-detail-info-left")?.getBoundingClientRect().width || 888
      const goodsDetaiTtabs = document.getElementById("goods-detail-tabs")
      if (goodsDetaiTtabs) {
        goodsDetaiTtabs.style.width = `${width}px`
      }

    }

    handleResize();
    const debouncedHandleResize = handleResize
    window.addEventListener('resize', debouncedHandleResize);

    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, []);

  const [tabs, setTabs] = useState("")

  const calculateFunction = (html: HTMLElement | null, tab: string) => {
    const newArrivals = document.getElementById('goods-detail-tabs');
    const navBox = document.getElementById('navbar-box');
    const newArrivalsHeight = newArrivals ? newArrivals.getBoundingClientRect().height : 0
    // const navBoxHeight = navBox ? navBox.getBoundingClientRect().height : 0
    if (html) {
      const rect1 = html.getBoundingClientRect();
      const scrollPosition = window.scrollY - newArrivalsHeight
      const top = rect1.top + scrollPosition - newArrivalsHeight
      const bottom = rect1.bottom + scrollPosition
      if (top <= scrollPosition && bottom >= scrollPosition) {
        if (tab != tabs) {
          setTabs(tab);
        }
      }
    }
  }

  const onChange = (key: string) => {
    // setTabs(key);
    if (window) {
      const focus = document.querySelector(":focus") as HTMLElement;
      focus && focus.blur();
    }

    // 滚动到指定位置
    const element = document.getElementById(key)
    if (element) {
      const newArrivals = document.getElementById('goods-detail-tabs');
      const navBox = document.getElementById('navbar-box');
      const newArrivalsHeight = newArrivals ? newArrivals.getBoundingClientRect().height : 0
      // 去掉navbar了
      // const navBoxHeight = navBox ? navBox.getBoundingClientRect().height : 0
      let offsetTop = Number(offSet(element).top) - newArrivalsHeight
      window.scrollTo({
        // 多一丢丢偏移
        top: parseFloat(`${offsetTop + 2}`),
        behavior: 'smooth',
      });
    }

  };

  // 页面onload再请求数据
  useEffect(() => {
    function handleWindowLoad() {
      getDetail()
    }
    
    window.addEventListener('load', handleWindowLoad);

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);

  const [descriptionHtml, setDescriptionHtml] = useState("")
  const [videoList, setVideoList]: any = useState([])
  const [featuresHtml, setfeaturesHtml] = useState("")
  const [specificationHtml, setspecificationHtml] = useState("")
  const [customList, setCustomList]: any = useState([])

  const imgRegex = /<img[^>]+>/g;
  const tableRegex = /<table[^>]+>/g;

  const upDateRichText = (richText: string) => {
    return richText
      .replace(imgRegex, (match) => {
        // 正则表达式模式匹配img标签的src和alt属性，无论它们的顺序如何
        const pattern = /<img[^>]*?(src|alt)=["'](.*?)["'][^>]*?(src|alt)=["'](.*?)["'][^>]*?>/g;

        let srcValue = '';
        let altValue = '';

        let matchResult: RegExpExecArray | null;

        while ((matchResult = pattern.exec(match))) {
          const attribute1 = matchResult[1];
          const value1 = matchResult[2];
          const attribute2 = matchResult[3];
          const value2 = matchResult[4];

          if (attribute1 === 'src') {
            srcValue = value1;
          } else if (attribute2 === 'src') {
            srcValue = value2;
          }

          if (attribute1 === 'alt') {
            altValue = value1;
          } else if (attribute2 === 'alt') {
            altValue = value2;
          }
        }

        // console.log(`src: ${srcValue}`);
        // console.log(`alt: ${altValue}`);

        if (srcValue) {
          // 将原本的img标签, 替换为next的image组件，以实现懒加载
          return `<Image
            key="${srcValue}"
            src="${srcValue}"
            alt="${altValue}"
            width={650}
            height={650}
            style='width: 100%; max-height: 100%;'
            loading="lazy"
          />`
        } else {
          console.log('description No img tag found or matching failed');
          return match.replace(">", " style='width: 100%; max-height: 100%;'>");
        }
      })
  }

  const upDateTable = (richText: string) => {
    if (!richText) {
      return ""
    }
    return richText
      .replace(/style=/g, "")
      .replace(tableRegex, (match) => {
        return match.replace(">", " style='width: 100% !important;'>");
      })
  }

  const getDetail = async () => {
    try {
      const res = await productApi.getDescription(props.productID)
      const { description, video } = res.data
      if (description) {
        const { features, product, specification, warranty } = description
        const newTabs = []
        if (product || props.courierID == 11) {
          newTabs.push({
            // key: 'goods-detail',
            key: 'description-box',
            label: 'Description'
          })
        }
        if (features) {
          newTabs.push({
            key: 'features-box',
            label: 'Features'
          })
        }
        if (specification) {
          newTabs.push({
            key: 'specification-box',
            label: 'Specification'
          })
        }
        const html = `<p style="font-weight:bold;margin-top:8px;"><br/>This item is an authentic parallel-import and items will be shipped from our supplier's warehouse and may take 2 to 3 days processing after payment confirmation. Parcel will be sent out by <b>DHL / UPS Courier Service</b> and may take 3 to 7 working days for delivery.<br/>If this product requires a charger, An Australian Certified Charger will be provided with this product instead of the original charger.(*Selected product only)</p>`
        let newDescriptionHtml = product ? product.content : ""
        if (props.courierID == 11) {
          newDescriptionHtml = newDescriptionHtml + html
        }
        newDescriptionHtml && setDescriptionHtml(`${upDateRichText(newDescriptionHtml)}`)
        features && setfeaturesHtml(features.content)
        specification && setspecificationHtml(upDateTable(specification.content))
        warranty && props.setWarrantyHtml(warranty.content)

        // features, product, specification, warranty以外的属性
        const blackList = ["features", "product", "specification", "warranty"]
        const customList = []
        for (const key in description) {
          if (Object.prototype.hasOwnProperty.call(description, key) && blackList.indexOf(key) == -1) {
            const element = description[key];
            newTabs.push({
              key: element.title,
              label: element.title
            })
            customList.push({
              name: element.title,
              html: element.content
            })
          }
        }

        setItems([...newTabs, ...items]);
        const defaultKey: any = newTabs.length > 0 ? setTabs(newTabs[0].key) : "product-reviews"
        setTabs(defaultKey)
        setCustomList(customList)

      }

      if (video && video.length) {
        setVideoList(video)
      }
    } catch (error: any) {
      message.error(error.message)
      console.log(error);
    }
  }

  // 图片hover
  useEffect(() => {
    const productDiv = document.getElementById('description-box');
    const imgElements = productDiv?.querySelectorAll('img');
    // 添加 hover 事件监听器
    imgElements?.forEach((img) => {
      img.addEventListener('mouseenter', handleImageHover);
    });
  }, [descriptionHtml])

  const [pinkitUrl, setPinkkitUrl] = useState("")
  // 处理图片 hover 事件的函数
  const handleImageHover = (event: any) => {
    const img = event.target;
    var url = props.url;
    var media = img.src;
    var description = props.name;
    var pos = media.indexOf("//") + 2;
    pos = pos >= 0 ? pos : 0;
    var leg = media.length;
    var ulrstr = media.slice(pos, leg);

    setPinkkitUrl("http://www.pinterest.com/pin/create/button/?url=" + url + "&media=http%3A%2F%2F" + ulrstr + "&description=" + description)

    const imgPosition = img.getBoundingClientRect();
    const productDiv = document.getElementById('description-box')?.getBoundingClientRect();
    const pinkit = document.getElementById("pinkit-btn")
    if (productDiv && pinkit) {
      const position = {
        top: imgPosition.top - productDiv.top,
        right: imgPosition.right - productDiv.right,
      };
      pinkit.style.right = `${position.right}px`
      pinkit.style.top = `${position.top}px`
      pinkit.style.display = `block`

    }
  }

  // 检查 URL 是否以视频格式后缀结尾
  const isDirectVideo = (url: string): boolean => {
    return url.match(/\.(mp4|mkv|webm|avi|mov|flv|wmv|m4v|mpg|mpeg)$/i) != null;
  };

  return (
    <div className={styles['goods-detail']} id="goods-detail" style={{ paddingTop: isBetween ? "68.28px" : "0" }}>
      <div className={`${isBetween && styles['fixed']}`} id='goods-detail-tabs' style={{ paddingLeft: "20px" }}>
        <Tabs activeKey={tabs} items={items} onChange={onChange} style={{ fontWeight: 'bold' }} />
      </div>
      <div className={styles['goods-info']}>
        {
          !!(props.preSales != 0 && props.preSales)
          &&
          <PreSaleContent />
        }
        {
          !!(descriptionHtml || videoList.length)
          &&
          <div className={styles['description-box']} id="description-box">
            <div className={styles['title']}>Product:</div>

            {
              !!(videoList && videoList.length) &&
              videoList.map((videoUrl: any, index: number) => {
                if (isDirectVideo(videoUrl)) {
                  return (
                    <video key={index} controls width="100%">
                      <source src={videoUrl} type={`video/${videoUrl.split('.').pop()}`} />
                      Your browser does not support the HTML5 video tag.
                    </video>
                  );
                } else {
                  // 如果是 YouTube 链接，需要转换为嵌入格式
                  let embedUrl = videoUrl;
                  if (videoUrl.includes('youtu.be') || videoUrl.includes('youtube.com')) {
                    embedUrl = videoUrl.replace('youtu.be/', 'youtube.com/embed/').replace('watch?v=', 'embed/');
                  }
                  // 如果需要支持其他视频服务，请在此添加更多的条件语句
                  return (
                    <iframe
                      key={index}
                      width="100%"
                      height="470px"
                      src={embedUrl}
                      style={{ border: '0' }}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  );
                }
              })
            }

            <div className={styles['rich-text']} dangerouslySetInnerHTML={{ __html: descriptionHtml }}></div>
            <Button type="link" target="_blank" href={pinkitUrl} className={styles['pinIt-btn']} id="pinkit-btn"><PinItSvg style={{ width: '100px' }} /></Button>
          </div>
        }

        <FineMore breadcrumb={props.breadcrumb} />


        <>
          {
            !!(props.ISBN && props.ISBN != 0)
            &&
            <p><strong>ISBN: </strong>{props.ISBN}</p>
          }
          {
            !!(props.MPN && props.MPN != 0)
            &&
            <p><strong>MPN: </strong>{props.MPN}</p>
          }
          {
            !!(props.UPC && props.UPC != 0)
            &&
            <p><strong>UPC: </strong>{props.UPC}</p>
          }
          {
            !!(props.vintage && props.vintage != 0)
            &&
            <p><strong>VINTAGE: </strong>{props.vintage}</p>
          }
        </>

        {
          featuresHtml
          &&
          <div className={styles['features-box']} id="features-box">
            <div className={styles['title']}>Features:</div>
            <div dangerouslySetInnerHTML={{ __html: featuresHtml }}></div>
          </div>
        }

        {
          specificationHtml
          &&
          <div className={styles['specification-box']} id="specification-box">
            <div className={styles['title']}>Specification:</div>
            <div style={{ overflow: 'hidden' }} dangerouslySetInnerHTML={{ __html: specificationHtml }}></div>
          </div>
        }

        {/* 其他自定义属性 */}
        {
          customList.map((v: any) => (
            <div className={styles['custom-box']} id={v.name} key={v.name}>
              <div className={styles['title']}>{v.name}:</div>
              <div dangerouslySetInnerHTML={{ __html: v.html }}></div>
            </div>
          ))
        }

        <FineMore productID={props.productID} />
      </div>
    </div>
  )
}


function PreSaleContent() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <div className={styles['preSaleContent']}>
        <div className={styles['img-box']}>
          <Image
            src='https://img.crazysales.com.au/images/newhomepage/total/detail-30-days.png'
            alt='img'
            preview={false}
          />
        </div>
        <div className={styles['apply-line']} onClick={showModal}>*Terms and conditions apply</div>
      </div>
      <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null} width={620}>
        <ul className={styles['modal']}>
          <li className={styles['tips']}>30 days pre-order price guarantee applies to all pre-order items on sales in m.crazysales.com.au; www.crazysales.com.au</li>
          <li className={styles['tips']}>30 days refer to 30 calendar days after your order starts processing for delivery in our warehouse; 30 days period exclude following special promotion: Flash sales, End of financial year, Click Frenzy, Black Friday, Christmas promotion, Boxing day promotion</li>
          <li className={styles['tips']}>Differences will be refund in form of Crazy Points, please contact our customer service with your order details and evident of lower price by e-mail to info@crazysales.com.au</li>
        </ul>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button type="primary" onClick={handleOk}>Got it !</Button>
        </div>
      </Modal>
    </>

  )
}